/***************************************************************************************************
** useArchetypes
***************************************************************************************************/

import { useMemo } from "react";
import useConfigFile from "@hooks/useConfigFile";

// const FIELD_TYPE_FNS = {
//   queryFields: buildQueryFieldProps,
//   formFields: buildFormFieldProps,
// };

export default function useArchetypes(resource, config = {}) {
  const archetypeFieldTypes = Object.keys(config);

  const hasArchetypes = archetypeFieldTypes.some((type) => config[type]?.flat().some((f) => f.$archetype));

  const filePath = hasArchetypes && `resources${resource}/_archetypes`;

  const [
    archetypeConfig,
    isArchetypeConfigLoaded,
    isArchetypeConfigPresent,
  ] = useConfigFile(filePath);

  // const archetypeFields = React.useMemo(() => {
  //   if (!isArchetypeConfigLoaded || !isArchetypeConfigPresent) return config;

  //   const calculatedFields = {};

  //   archetypeFieldTypes.forEach(type => {
  //     const buildFieldPropsFn = FIELD_TYPE_FNS[type];

  //     if (config[type]) {
  //       calculatedFields[type] = Array.isArray(config[type])
  //         ? config[type].map(rowFields => buildArchetypeFields(rowFields, archetypeConfig[type], buildFieldPropsFn))
  //         : buildArchetypeFields(config[type], archetypeConfig[type], buildFieldPropsFn);
  //     }
  //   });

  //   return { ...config, ...calculatedFields };
  // }, [
  //   config,
  //   archetypeConfig,
  //   archetypeFieldTypes,
  //   isArchetypeConfigLoaded,
  //   isArchetypeConfigPresent,
  // ]);

  /***************************************************************************************************
  ** queryFields
  ***************************************************************************************************/

  const queryFields = useMemo(() => {
    if (!hasArchetypes) return config.queryFields;
    if (!isArchetypeConfigLoaded || !isArchetypeConfigPresent) return config.queryFields;

    return buildArchetypeFields(config.queryFields, archetypeConfig.queryFields, buildQueryFieldProps);
  }, [
    config.queryFields,
    archetypeConfig,
    hasArchetypes,
    isArchetypeConfigLoaded,
    isArchetypeConfigPresent,
  ]);

  /***************************************************************************************************
  ** formFields
  ***************************************************************************************************/

  // const formFields = React.useMemo(() => {
  //   if (!hasFormFieldArchetypes) return config.formFields;
  //   if (!isArchetypeConfigLoaded || !isArchetypeConfigPresent) return config.formFields;

  //   return config.formFields?.map((rowFields) => {
  //     return buildArchetypeFields(rowFields, archetypeConfig.formFields, buildFormFieldProps);
  //   });
  // }, [
  //   config.formFields,
  //   archetypeConfig,
  //   hasFormFieldArchetypes,
  //   isArchetypeConfigLoaded,
  //   isArchetypeConfigPresent,
  // ]);

  /**************************************************************************************************/

  return {
    queryFields,
    // formFields,
  };
}

const buildArchetypeFields = (fields, archetypeFields, buildFieldPropsFn) => {
  if (!archetypeFields) return fields;

  return fields.map((field) => {
    // Return field if no archetype key
    if (!field.$archetype) return field;

    // Separate fieldOverrides from archetype key
    const { $archetype, ...fieldOverrides } = field;

    // Retrieve archetypeField via key
    const archetypeField = archetypeFields[$archetype];

    // Return fieldOverrides if archetypeField is not found
    if (!archetypeField) return fieldOverrides;

    // If fieldOverrides is empty, return archetype values
    if (Object.keys(fieldOverrides).length === 0) return archetypeField;

    return buildFieldPropsFn(archetypeField, fieldOverrides);
  }).filter(Boolean);
};

const mergeProps = (archetype, overrides, propName) => {
  if (!overrides[propName]) {
    return archetype[propName];
  } else if (overrides[propName].__reset) {
    const { __reset, ...rest } = overrides[propName];
    return rest;
  } else {
    return { ...archetype[propName], ...overrides[propName] };
  }
};

const buildQueryFieldProps = (archetype, overrides) => {
  const props = {};

  props.type = overrides.type || archetype.type;

  props.label = overrides.label || archetype.label;
  props.labelIcon = overrides.labelIcon || archetype.labelIcon;
  props.labelTooltip = overrides.labelTooltip || archetype.labelTooltip;

  props.sortKey = overrides.sortKey || archetype.sortKey;
  props.sortLabel = overrides.sortLabel || archetype.sortLabel;

  props.styles = mergeProps(archetype, overrides, "styles");
  props.config = mergeProps(archetype, overrides, "config");

  return props;
};

// const buildFormFieldProps = (archetype, overrides) => {
//   const props = {};

//   props.name = overrides.name || archetype.name;
//   props.type = overrides.type || archetype.type;
//   props.width = overrides.width || archetype.width;

//   props.styles = mergeProps(archetype, overrides, 'styles');
//   props.config = mergeProps(archetype, overrides, 'config');

//   return props;
// };
